import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfirmationService, FileUploadModule } from 'primeng/primeng';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, Http, XHRBackend } from '@angular/http';
// import {HttpErrorResponse} from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MomentModule } from 'angular2-moment';

import {
    InputTextModule,
	DropdownModule,
	ButtonModule,
	ConfirmDialogModule,
    AutoCompleteModule,
	PanelModule,
	DataTableModule,
	DialogModule,
	OverlayPanelModule,
    PaginatorModule,
    CheckboxModule
} from 'primeng/primeng';

import { routes } from './app.routes';

// import { AppSettings } from './settings/index';
import { AuthHttp } from './infrastructure/common';

import {
    AuthenticationService,
    ReportFormatService,
    UserService,
    AuthenticateXHRBackend,
	MenuService
} from './infrastructure/services/base';

import {
    ContractDetailsService,
    CustomerAddressService,
    DriverService,
    InventoryStatusService,
    HolidayService,
    OnlineOrderDocumentService,
    OnlineOrderLineService,
    OnlineOrderReportService,
    OnlineOrderTypeService,
    ShipmentService,
    OnlineOrderService,
    OnlineOrderServiceService,
    PreferredDeliveryTimeSlotService
} from './infrastructure/services/transaction/op/outbound/order';

import {
    ChargeService
} from './infrastructure/services/master/om/index';

import {
    ProductService,
	ProductConfigService,
    ProductUomService
} from './infrastructure/services/master/wm/index';

import {
    WarehouseAuthService
} from './infrastructure/services/master/wm/config/index';

import {
    OnlineProductInventoryGridConfigService,
    OnlineUserProductConfigService,
} from './infrastructure/services/master/op';

import {
    AnnouncementService,
	AnnouncementStatusService
} from './infrastructure/services/transaction/op/announcement/index';

import {
    TicketService,
} from './infrastructure/services/transaction/op/outbound/ticket';

import {
    ContainerSizeService
} from './infrastructure/services/master/hm';

import {
    TruckSizeService,
    TimeSlotService,
    TicketStatusService,
    GoogleGeocodeService
} from './infrastructure/services/master/op';

import { OwnerService } from './infrastructure/services/master/wm/business-partner/owner.service';
import { CustomerService } from './infrastructure/services/master/wm/business-partner/customer.service';

import { DataService } from './infrastructure/services/base/config/data.service';

import { AppComponent } from './app.component';
import { PagesComponent } from './views/pages/pages.component';

// Security
import { LoginComponent } from './views/pages/base/security/login/login.component';
import { ForgotPasswordComponent } from './views/pages/base/security/login/forgot-password.component';
import { ResetPasswordComponent } from './views/pages/base/security/login/reset-password.component';
import { ChangePasswordComponent } from './views/pages/base/security/change-password/change-password.component';

// Config
import { UserManagerComponent } from './views/pages/base/security/user-manager/user-manager.component';

// Reports
import { InventoryBalanceReportComponent } from './views/pages/transaction/reports/inventory-balance-report/inventory-balance-report.component';
import { InventoryBalanceAvailableReportComponent } from './views/pages/transaction/reports/inventory-balance-available-report/inventory-balance-available-report.component';
import { InventoryBalanceByAsnReportComponent } from './views/pages/transaction/reports/inventory-balance-by-asn/inventory-balance-by-asn-report.component';
import { InventoryBalanceByProductReportComponent } from './views/pages/transaction/reports/inventory-balance-by-product/inventory-balance-by-product-report.component';
import { InventoryBalanceByWarehouseReportComponent } from './views/pages/transaction/reports/inventory-balance-by-warehouse/inventory-balance-by-warehouse-report.component';

// Announcement
import { AnnouncementListComponent } from './views/pages/master/op/announcement/announcement-list/announcement-list.component';
import { AnnouncementDetailsComponent } from './views/pages/master/op/announcement/announcement-details/announcement-details.component';
import { AnnouncementComponent } from './views/pages/master/op/announcement/announcement/announcement.component';

//Inbound
import { SubmitAsnComponent } from './views/pages/transaction/op/inbound/asn/submit-asn/submit-asn.component';
import { ASNChooseAccountComponent } from './views/pages/transaction/op/inbound/asn/submit-asn/choose-account/choose-account.component';
import { ASNFillInfoComponent } from './views/pages/transaction/op/inbound/asn/submit-asn/fill-info/fill-info.component';
import { ASNSelectProductsComponent } from './views/pages/transaction/op/inbound/asn/submit-asn/select-products/select-products.component';
import { AsnListComponent } from './views/pages/transaction/op/inbound/asn/asn-list/asn-list.component';
import { ASNSummaryComponent } from './views/pages/transaction/op/inbound/asn/submit-asn/summary/summary.component';

import { OnlineShippingNoticeService } from './infrastructure/services/transaction/op/inbound/asn/online-shipping-notice.service';

// TODO
import { InvoiceReportComponent } from './views/pages/transaction/reports/invoice-report/invoice-report.component';
import { LoadingBookingComponent } from './views/pages/transaction/op/outbound/booking/loading-booking/loading-booking.component';
import { CreateBookingComponent } from './views/pages/transaction/op/outbound/booking/create-booking/create.component';
import { UserGroupComponent } from './views/pages/base/security/user-group/user-group.component';
import { UserComponent } from './views/pages/base/security/user/user.component';
import { ErrorComponent } from './views/pages/base/config/error/error.component';
import { AboutComponent } from './views/pages/base/config/about/about.component';
import { TicketEntryComponent } from './views/pages/transaction/op/outbound/ticket/ticket-entry/ticket-entry.component';
import { TicketTrackingComponent } from './views/pages/transaction/op/outbound/ticket/ticket-tracking/ticket-tracking.component';
import { TicketConfirmationComponent } from './views/pages/transaction/op/outbound/ticket/ticket-confirmation/ticket-confirmation.component';
import { UploadTemplateComponent } from './views/pages/transaction/interface/upload-template/upload-template.component';
import { ReportService } from './infrastructure/common/report.service';
import { CssConfigService } from './infrastructure/services/base/config/css.service';
import { HttpClientModule } from '@angular/common/http';
import { FileUploadValueAccessor } from './infrastructure/settings/file-upload-value-accessor';
import { AuthGuard } from './infrastructure/services/base/security/auth-guard';
import { InventoryProductComponent } from './views/pages/transaction/reports/inventory-product/inventory-product.component';
import { SingaporePostalCodeService } from './infrastructure/services/base/config/singaporepostalcode.service';
import { InventoryBalanceLWINReportComponent } from './views/pages/transaction/reports/inventory-balance-lwin-report/inventory-balance-lwin-report.component';

export function authHttpFactory(http: Http) {
    return new AuthHttp(http);
}

@NgModule({
    declarations: [
        AppComponent,

        ChangePasswordComponent,
        LoginComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,

        InventoryBalanceAvailableReportComponent,
        UserManagerComponent,

        AnnouncementListComponent,
        AnnouncementDetailsComponent,
        AnnouncementComponent,

        LoadingBookingComponent,
        CreateBookingComponent,
        InvoiceReportComponent,
        UserComponent,
        UserGroupComponent,
        ErrorComponent,
        PagesComponent,
        AboutComponent,
        TicketEntryComponent,
        TicketTrackingComponent,
        TicketConfirmationComponent,

        InventoryBalanceByAsnReportComponent,
        InventoryBalanceByProductReportComponent,
        InventoryBalanceByWarehouseReportComponent,

        SubmitAsnComponent,
        ASNChooseAccountComponent,
        ASNFillInfoComponent,
        ASNSelectProductsComponent,
        ASNSummaryComponent,
        AsnListComponent,
        InventoryProductComponent,
        InventoryBalanceLWINReportComponent
    ],
    imports: [
        RouterModule,
        BrowserModule,
        FormsModule,
        HttpModule,
        HttpClientModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(routes),
        InputTextModule,
        DropdownModule,
        ButtonModule,
        ConfirmDialogModule,
        AutoCompleteModule,
        PanelModule,
        DataTableModule,
        DialogModule,
        OverlayPanelModule,
        CheckboxModule,
        PaginatorModule,
        MomentModule,
        FileUploadModule,
        AutoCompleteModule
    ],
    providers: [
        ConfirmationService,
        {
            provide: AuthHttp,
            useFactory: authHttpFactory,
            deps: [Http]
        },
        {
            provide: XHRBackend,
            useClass: AuthenticateXHRBackend
        },
        // Base
        AuthenticationService,
        UserService,

        // Online Order
        ContractDetailsService,
        CustomerAddressService,
        DriverService,
        InventoryStatusService,
        HolidayService,
		    ChargeService,
        OnlineOrderDocumentService,
        OnlineOrderLineService,
        OnlineOrderReportService,
        OnlineOrderTypeService,
        ShipmentService,
        OnlineOrderService,
        OnlineOrderServiceService,
        AnnouncementService,
        AnnouncementStatusService,
        OnlineUserProductConfigService,
        PreferredDeliveryTimeSlotService,
        ProductConfigService,
        ProductService,
        ProductUomService,
        ReportFormatService,
        WarehouseAuthService,
        OnlineProductInventoryGridConfigService,
        // ticket
        TicketService,

        // hm.resources-setup
        ContainerSizeService,

        // wm.online-portal
        TruckSizeService,
        TimeSlotService,
        TicketStatusService,
        GoogleGeocodeService,

        // business-partner
        OwnerService,
		    CustomerService,

        //report
        ReportService,

        //inbound
        OnlineShippingNoticeService,

		    // menu
        MenuService,

        // css
        CssConfigService,

        // singaporepostalcode
        SingaporePostalCodeService,

        DataService,
        AuthGuard],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts